module.exports = __webpack_public_path__ + "img/tort.ddb88fb5.png";